import React from "react";
import "../../styles/registration.css";
import banner from "../../assets/banner.png";
import { useNavigate } from "react-router-dom";


const Banner = () => {
    const navigate = useNavigate();

  return (
    <section className="banner-section p-3">
      {/* The main card container */}
      <div className="banner-card">
        
        {/* LEFT SIDE: Content */}
        <div className="banner-content">
          <h5 className="banner-subtitle">
            Focused Coaching for CA | CMA | CS
          </h5>
          
          <h2 className="banner-title">
            Learn Smart, Achieve Big
          </h2>

          <button className="register-btn" onClick={() => navigate("/contact")}>Register Now</button>
        </div>

        {/* RIGHT SIDE: Image */}
        <div className="banner-image-container">
          <img
            src={banner}
            alt="Professional Coaching"
            className="banner-img"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Banner;